"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEntityJson = exports.stringifyEntityJson = void 0;
function isDate(obj) {
    if (Object.prototype.toString.call(obj) !== '[object Date]') {
        return false;
    }
    return !isNaN(obj.getTime());
}
var isDateString = function (string) { return !Number.isNaN(Date.parse(string)); };
function parseEntityJson(entityJson) {
    var lastDate = null;
    return JSON.parse(entityJson, function (k, v) {
        if (k === '$date' && isDateString(v)) {
            lastDate = new Date(v);
        }
        else if (k === '$date') {
            lastDate = { '$date': v };
        }
        else if (lastDate !== null) {
            var tmp = lastDate;
            lastDate = null;
            return tmp;
        }
        else {
            return v;
        }
    });
}
exports.parseEntityJson = parseEntityJson;
function stringifyEntityJson(item) {
    function transform(key, value) {
        var self = this;
        return stringifyDateReplacer.call(self, key, value);
    }
    return JSON.stringify(item, transform);
}
exports.stringifyEntityJson = stringifyEntityJson;
function stringifyDateReplacer(k, v, chain) {
    if (k && isDate(this[k])) {
        return stringifyDate(this[k]);
    }
    if (chain) {
        return chain(k, v);
    }
    else {
        return v;
    }
}
function stringifyDate(v) {
    return {
        '$date': v.toJSON()
    };
}
//# sourceMappingURL=serialization.js.map